import {Link, ListItemSecondaryAction, makeStyles} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";
import React, {Fragment} from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ListItem from "@material-ui/core/ListItem";
import clsx from "clsx";
import ListItemText from "@material-ui/core/ListItemText";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {useTheme} from "@material-ui/core/styles";
import {useMediaQuery} from "@material-ui/core/index";
import {ArrowForwardIos} from "@material-ui/icons";
import {Link as RouterLink} from "react-router-dom";

export const useOrgUnitItemStyles = makeStyles(theme => ({
    firstOrganizationUnit: {
        position: 'relative',
        height: '100%',
        cursor: "inherit",
        '&:hover': {
            backgroundColor: 'white',
            '& svg': {
                backgroundColor: grey[50]
            }
        },
    },
    childOrganizationUnit: {
        paddingLeft: '40px',
        height: '100%',
        '& > div': {
            whiteSpace: 'nowrap'
        }
    },
    siblingOrganizationUnit: {
        '&:hover': {
            color: grey[50],
            backgroundColor: grey[800],
        }
    },
    listPadding: {
        padding: '0',
        paddingTop: '1px'
    },
    hasBackButton: {
        paddingLeft: '40px'
    },
    backIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        marginLeft: 15,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer'
    },
    childrenList: {
        overflowY: 'scroll'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    separatorContainer: {
        position: 'relative',
    },
    separator: {
        height: '1px',
        width: 'calc(100% - 40px)',
        position: 'absolute',
        left: '40px',
        bottom: '0px',
        backgroundColor: grey[500],
    },
    listItemText: {
        overflow: 'hidden',
        display: '-webkit-box',
        'line-clamp': '3',
        '-webkit-box-orient': 'vertical'
    },
    currentOrgUnitListItem: {
        'line-clamp': '2',
    }
}));

export const OrganizationUnitListItem = (props: any) => {
    const classes = useOrgUnitItemStyles();
    const {organizationUnit, children, isDisplayedAsChild} = props;
    const isDisplayedAsSibling = !organizationUnit.isSelected && !isDisplayedAsChild;
    const raiseOrganizationUnitIdChanged = props.onOrganizationUnitIdChanged;
    const raiseOrganizationUnitContextMenuOptionClicked = props.onOrganizationUnitContextMenuOptionClicked;
    const organizationUnitSearch = props.organizationUnitSearch;
    const organizationUnitContextMenuOptions = props.organizationUnitContextMenuOptions;
    const [contextMenuAnchor, setContextMenuAnchor] = React.useState(null);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const handleGoBackToParent = (event: any) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return raiseOrganizationUnitIdChanged(organizationUnit.parentId);
    };
    // TODO: Replace !isTop by parents.length ?
    const goToParentButton = !organizationUnit.isTop && !isDisplayedAsChild && organizationUnit.parentId ?
        <div className={classes.backIcon}
             onClick={handleGoBackToParent}>
            <ArrowBackIosIcon/>
        </div>
        : null;

    const onContextMenuClicked = (event: any) => {
        setContextMenuAnchor(event.currentTarget);
    };

    const onContextMenuOptionClicked = (event: any, key: any) => {
        if (raiseOrganizationUnitContextMenuOptionClicked) {
            raiseOrganizationUnitContextMenuOptionClicked({organizationUnitId: organizationUnit.id, key});
        }
        setContextMenuAnchor(null);
    };

    const onContextMenuClosed = (event: any) => {
        setContextMenuAnchor(null);
    };

    return (
        <React.Fragment>
            <ListItem button
                      classes={{
                          container: isDisplayedAsChild && classes.container,
                      }}
                      key={`orgUnit-${organizationUnit.id}-button`}
                      onClick={() => raiseOrganizationUnitIdChanged(organizationUnit.id)}
                      disableRipple={!isDisplayedAsChild}
                      className={clsx(!organizationUnit.isTop && !isDisplayedAsChild && organizationUnit.parentId && classes.hasBackButton,
                          organizationUnit.isSelected && classes.firstOrganizationUnit,
                          isDisplayedAsSibling && classes.siblingOrganizationUnit,
                          isDisplayedAsChild && classes.childOrganizationUnit)}>
                {goToParentButton}
                <ListItemText
                    className={clsx(classes.listItemText, !isDisplayedAsChild && classes.currentOrgUnitListItem)}
                    primary={`${organizationUnit.name}`}
                />
                <ListItemSecondaryAction>
                    {isMobile ?
                        <Fragment>
                            <MoreHorizIcon
                                onClick={onContextMenuClicked}
                            />
                            <Menu
                                anchorEl={contextMenuAnchor}
                                keepMounted
                                open={Boolean(contextMenuAnchor)}
                                onClose={onContextMenuClosed}
                            >
                                {organizationUnitContextMenuOptions.map((option: any) => <MenuItem
                                        onClick={(event) => onContextMenuOptionClicked(event, option.key)}
                                        key={`orgUnit-${organizationUnit.id}-context-menu-${option.key}`}>
                                        {option.text}
                                    </MenuItem>
                                )}
                            </Menu> </Fragment> :
                        <Link component={RouterLink}
                              to={`/organization-units/${organizationUnit.id}/detail?tab=0`}>
                            <ArrowForwardIos fontSize={"small"}/>
                        </Link>
                    }
                </ListItemSecondaryAction>
            </ListItem>
            {
                isDisplayedAsChild &&
                <div className={classes.separatorContainer}>
                    <div className={classes.separator}></div>
                </div>
            }
            {organizationUnit.isSelected && organizationUnitSearch}
            {organizationUnit.isSelected && !!children && children}
        </React.Fragment>
    );
};
